/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolutionHistoryEntry
 */
export interface ResolutionHistoryEntry {
    /**
     * 
     * @type {string}
     * @memberof ResolutionHistoryEntry
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ResolutionHistoryEntry
     */
    resolutionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ResolutionHistoryEntry
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolutionHistoryEntry
     */
    resolutionStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolutionHistoryEntry
     */
    resolutionMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolutionHistoryEntry
     */
    resolvedCatalogId?: string;
    /**
     * 
     * @type {number}
     * @memberof ResolutionHistoryEntry
     */
    controlsSelected?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolutionHistoryEntry
     */
    controlsExcluded?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolutionHistoryEntry
     */
    controlsModified?: number;
    /**
     * 
     * @type {string}
     * @memberof ResolutionHistoryEntry
     */
    resolutionMessages?: string;
}

/**
 * Check if a given object implements the ResolutionHistoryEntry interface.
 */
export function instanceOfResolutionHistoryEntry(value: object): value is ResolutionHistoryEntry {
    return true;
}

export function ResolutionHistoryEntryFromJSON(json: any): ResolutionHistoryEntry {
    return ResolutionHistoryEntryFromJSONTyped(json, false);
}

export function ResolutionHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolutionHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'resolutionDate': json['resolutionDate'] == null ? undefined : (new Date(json['resolutionDate'])),
        'resolvedBy': json['resolvedBy'] == null ? undefined : json['resolvedBy'],
        'resolutionStatus': json['resolutionStatus'] == null ? undefined : json['resolutionStatus'],
        'resolutionMethod': json['resolutionMethod'] == null ? undefined : json['resolutionMethod'],
        'resolvedCatalogId': json['resolvedCatalogId'] == null ? undefined : json['resolvedCatalogId'],
        'controlsSelected': json['controlsSelected'] == null ? undefined : json['controlsSelected'],
        'controlsExcluded': json['controlsExcluded'] == null ? undefined : json['controlsExcluded'],
        'controlsModified': json['controlsModified'] == null ? undefined : json['controlsModified'],
        'resolutionMessages': json['resolutionMessages'] == null ? undefined : json['resolutionMessages'],
    };
}

export function ResolutionHistoryEntryToJSON(json: any): ResolutionHistoryEntry {
    return ResolutionHistoryEntryToJSONTyped(json, false);
}

export function ResolutionHistoryEntryToJSONTyped(value?: ResolutionHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'resolutionDate': value['resolutionDate'] == null ? undefined : ((value['resolutionDate']).toISOString()),
        'resolvedBy': value['resolvedBy'],
        'resolutionStatus': value['resolutionStatus'],
        'resolutionMethod': value['resolutionMethod'],
        'resolvedCatalogId': value['resolvedCatalogId'],
        'controlsSelected': value['controlsSelected'],
        'controlsExcluded': value['controlsExcluded'],
        'controlsModified': value['controlsModified'],
        'resolutionMessages': value['resolutionMessages'],
    };
}

